import type { Group, Person } from 'core';

export const isAdmin = (group: Group.Type, person: Person.Type): boolean =>
  group.admin?.personIds?.includes(person._id) ?? false;
export const isMember = (group: Group.Type, person: Person.Type): boolean =>
  group.members?.includes(person._id) ?? false;
